import { color } from '../../../resources/color';

export const getClaimStatusTextColor = (status) => {
  switch (status) {
    case 'WAIT':
      return color.green_pixel;
    case 'WAIT_PAYMENT':
      return color.green_pixel;
    case 'PREPARING':
      return color.green_pixel;
    case 'TRANSPORTED':
      return color.green_pixel;
    case 'REJECTED':
      return color.red;
    default:
      return color.gray;
  }
};

export const getClaimStatusBgColor = (status) => {
  switch (status) {
    case 'WAIT':
      return color.light_green_pixel;
    case 'WAIT_PAYMENT':
      return color.light_green_pixel;
    case 'PREPARING':
      return color.bg_yellow;
    case 'TRANSPORTED':
      return color.bg_green;
    case 'REJECTED':
      return color.bg_red;
    default:
      return color.bg_gray;
  }
};

export const getExpCoupon = (type) => {
  return type === 'BIRTHDAY' ? 'เฉพาะในเดือนเกิด' : 'ตลอดอายุการเป็นสมาชิก 1 ปี';
};
